import { render, staticRenderFns } from "./BtnAtivarDesativarFeriado.vue?vue&type=template&id=71147053"
import script from "./BtnAtivarDesativarFeriado.vue?vue&type=script&lang=js"
export * from "./BtnAtivarDesativarFeriado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports